import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function CacheRouteWatcherComponent() {
  const location = useLocation();
  let cache_name: string;

  useEffect(() => {
    if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
      // Crea un canale di comunicazione con il Service Worker
      const messageChannel = new MessageChannel();

      // Ascolta la risposta dal Service Worker
      messageChannel.port1.onmessage = (event) => {
        cache_name = event.data.constantValue;
      };

      // Invia il messaggio al Service Worker per chiedere la costante
      navigator.serviceWorker.controller.postMessage(
        { type: "GET_CONSTANT" },
        [messageChannel.port2] // Passa il canale di risposta
      );
    }
    // Ogni volta che cambia l'URL, esegui la funzione per cacheare la pagina
    cacheCurrentPage(location.pathname);
  }, [location]);

  const cacheCurrentPage = async (url: string) => {
    // Verifica che il Service Worker sia registrato e attivo
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
      try {
        // Fetch della risorsa corrispondente alla route attuale
        const response = await fetch(url);
        
        if (response.status === 200) {
          // Apre la cache dinamica e salva la risorsa nella cache
          const cache = await caches.open(cache_name);
          await cache.put(url, response.clone());
          //console.log(`Risorsa cacheata per la route: ${url}`);
        }
      } catch (error) {
        //console.error('Errore durante la cache della pagina:', error);
      }
    }
  };

  return null; // Questo componente è solo per side-effects
}
